/** Russian core dashboard strings matching the English `en` dictionary. */
export const ruCore = {
  common: {
    loading: 'Загрузка…',
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    add: 'Добавить',
    create: 'Создать',
    signOut: 'Выйти',
    signIn: 'Войти',
    copy: 'Копировать',
    retry: 'Повторить',
    search: 'Поиск…',
    noData: 'Данных пока нет.',
    required: 'обязательно',
    optional: 'необязательно',
  },
  nav: {
    clients: 'Клиенты',
    dashboard: 'Панель',
    sales: 'Продажи',
    menuInsights: 'Аналитика меню',
    staffInsights: 'Аналитика персонала',
    staffComps: 'Комплименты сотрудникам',
    businessHealth: 'Здоровье бизнеса',
    inventoryInsights: 'Склад',
    purchases: 'Закупки',
    orders: 'Заказы',
    shifts: 'Смены',
    timesheet: 'Табель',
    stockCount: 'Инвентаризация',
    cashDrops: 'Инкассация',
    menu: 'Меню',
    modifiers: 'Модификаторы',
    ingredients: 'Ингредиенты',
    recipes: 'Рецепты',
    users: 'Пользователи',
    cashiers: 'Кассиры',
    receipt: 'Чек',
    customerDisplay: 'Экран гостя',
    invoices: 'Накладные',
    stockIn: 'Приход',
    waste: 'Журнал списаний',
    prepBatches: 'Заготовки',
    suppliers: 'Поставщики',
    staff: 'Сотрудники',
    floorPlan: 'План зала',
    bookings: 'Бронирования',
    bookingInsights: 'Аналитика броней',
    rooms: 'Бронирования',
    settings: 'Настройки',
    posDiagnostics: 'Диагностика POS',
    loyalty: 'Лояльность',
  },
  posDiagnostics: {
    title: 'Диагностика POS',
    hint: 'Снимки, отправленные с терминалов POS (CSV заказов, очередь, журнал приложения).',
    empty: 'Диагностических выгрузок ещё нет.',
    download: 'Скачать',
  },
  auth: {
    username: 'Имя пользователя',
    email: 'Электронная почта',
    password: 'Пароль',
    signingIn: 'Вход…',
    noRoleTitle: 'Роль не назначена',
    noRoleBody: 'У этого аккаунта ещё нет роли. Попросите суперадминистратора выдать доступ.',
    notConfiguredTitle: 'Supabase не настроен',
    resetPasswordTitle: 'Задайте новый пароль',
    resetPasswordBody: 'Выберите новый пароль для аккаунта.',
    newPassword: 'Новый пароль',
    confirmPassword: 'Подтвердите пароль',
    updatePassword: 'Обновить пароль',
    passwordMismatch: 'Пароли не совпадают.',
    forgotPassword: 'Забыли пароль?',
    forgotPasswordTitle: 'Сброс пароля',
    forgotPasswordBody: 'Введите почту — мы отправим ссылку для сброса.',
    sendResetLink: 'Отправить ссылку',
    resetLinkSent: 'Проверьте почту: мы отправили ссылку для сброса.',
    backToSignIn: 'Назад ко входу',
  },
  stockCount: {
    title: 'Инвентаризация',
    subtitle: 'Пройдите по складу и введите фактические остатки.',
    subtitleSingle: 'Найдите ингредиент, введите пересчитанное количество и сохраните по одному.',
    viewLossInsights: 'Потери и расхождения',
    system: 'Система',
    counted: 'Пересчитано',
    lineNote: 'Заметка (необязательно)',
    sessionNote: 'Заметка сессии (необязательно)',
    countedAt: 'Время пересчёта',
    countedNow: 'Время пересчёта',
    changeTime: 'Изменить время',
    hideTime: 'Использовать сейчас',
    post: 'Провести инвентаризацию',
    saveOne: 'Сохранить пересчёт',
    savedOne: '{{name}} пересчитан и сохранён.',
    savedMatched: '{{name}} пересчитан — совпадает с системой ✓',
    savedVariance: '{{name}} сохранён · {{delta}} {{unit}} к системе',
    matched: 'Совпадает с системой',
    recount: 'Пересчитать заново',
    allDone: 'Все ингредиенты пересчитаны в этой сессии.',
    enterQty: 'Введите пересчитанное количество.',
    confirmTitle: 'Провести инвентаризацию?',
    confirmBody: 'Пересчитано позиций: {{counted}} · расхождений {{variances}} обновят остаток.',
    progress: '{{done}} / {{total}} пересчитано',
    varianceCount: '{{count}} расхождений',
    noResults: 'Подходящих ингредиентов нет.',
    nothingCounted: 'Перед проведением пересчитайте хотя бы один ингредиент.',
    invalidQty: 'Некорректное количество для {{name}}.',
    invalidTime: 'Некорректное время пересчёта.',
    futureTime: 'Время пересчёта не может быть в будущем.',
    filter: {
      all: 'Все',
      remaining: 'Осталось',
      done: 'Готово',
      uncounted: 'Осталось',
      variance: 'Расхождение',
      low: 'Низкий остаток',
    },
    postedVariances: 'Проведённые расхождения',
    postedVariancesHint: 'Недавние строки пересчёта, которые изменили остаток. Отмените ошибочный пересчёт здесь — он останется в истории, но не войдёт в метрики потерь.',
    noPostedVariances: 'Проведённых расхождений ещё нет.',
    revert: 'Отменить',
    reverted: 'Отменено',
    revertSuccess: 'Пересчёт отменён — остаток восстановлен.',
    colWhen: 'Когда',
    colIngredient: 'Ингредиент',
    colDelta: 'Дельта',
    colDetail: 'Подробности',
    sessionTeamCount: 'Идёт командный пересчёт',
    sessionOpenedBy: 'Начал {{name}} · {{when}}',
    sessionSomeone: 'Кто-то',
    sessionClose: 'Закрыть сессию',
    sessionClosedSuccess: 'Сессия инвентаризации закрыта.',
    sessionNoActive: 'Нет активной сессии пересчёта',
    sessionNoActiveHint: 'Начните сессию, чтобы команда видела, что уже пересчитано и что осталось. Остаток по-прежнему обновляется сразу при каждом сохранении.',
    sessionStart: 'Начать сессию',
    sessionLive: 'Живые обновления от команды',
    sessionCountedBy: 'Пересчитал {{name}}',
  },
  wasteLog: {
    title: 'Списание',
    subtitle: 'Фиксируйте списанные ингредиенты. Отчёты — в аналитике склада.',
    viewInsights: 'Аналитика списаний',
    viewAll: 'Все списания',
    ingredient: 'Ингредиент',
    ingredientPlaceholder: 'Поиск ингредиента…',
    stock: 'Остаток',
    qty: 'Количество',
    reason: 'Причина',
    note: 'Заметка',
    notePlaceholder: 'Необязательные детали',
    submit: 'Зафиксировать списание',
    recent: 'Недавние',
    none: 'Списаний ещё нет.',
    pickIngredient: 'Выберите ингредиент.',
    positiveQty: 'Введите положительное количество.',
  },
  cashiers: {
    title: 'Кассиры',
    subtitle: 'Создавайте входы POS для сотрудников.',
    usernamePlaceholder: 'Имя пользователя (логин)',
    fullNamePlaceholder: 'Имя и фамилия',
    hdmNo: 'Номер кассира HDM',
    create: 'Создать кассира',
    credsTitle: 'Данные кассира',
    credsNote: 'Скопируйте и отправьте кассиру. Показываются только один раз.',
  },
  menu: {
    title: 'Меню',
    categories: 'Категории',
    products: 'Товары',
    addCategory: 'Добавить категорию',
    addProduct: 'Добавить товар',
    importCsv: 'Импорт CSV',
    priceList: 'Прайс-лист',
    allCategories: 'Все',
    print: 'Печать',
    openRecipe: 'Открыть рецепт',
  },
  ingredients: {
    title: 'Ингредиенты',
    addIngredient: 'Добавить ингредиент',
    importCsv: 'Импорт CSV',
    restock: 'Пополнить',
    lowStock: 'Низкий остаток',
    colName: 'Название',
    colUnit: 'Единица',
    colStock: 'Остаток',
    colCost: 'Себестоимость',
    noIngredients: 'Ингредиентов ещё нет.',
    merge: 'Объединить ингредиенты',
    mergeTitle: 'Объединить дубликаты ингредиентов',
    mergeDescription: 'Объедините два обычных ингредиента в один. Ссылки перейдут на оставшуюся строку; остаток и себестоимость суммируются. Заготовки объединять нельзя.',
    mergeKeep: 'Оставить (основной)',
    mergeRemove: 'Поглотить (удалить)',
    mergeSelectKeep: 'Выберите ингредиент, который оставить…',
    mergeSelectRemove: 'Выберите дубликат для объединения…',
    mergePreview: 'Предпросмотр',
    mergeRecipes: 'Затронутые строки рецептов',
    mergeWillCombine: 'количество объединится в том же рецепте',
    mergeWillRepoint: 'перенаправлено',
    mergeSubstitutes: 'Варианты замены',
    mergeChoiceOptions: 'Варианты выбора',
    mergePurchaseLines: 'Строки заказов поставщикам',
    mergeTransactions: 'Складские операции',
    mergeCombinedStock: 'Объединённый остаток',
    mergeCombinedCost: 'Объединённая цена за единицу',
    mergeUnitMismatch: 'Для объединения единицы должны совпадать.',
    mergePrepBlocked: 'Заготовки объединять нельзя.',
    mergeConfirm: 'Объединить ингредиенты',
    mergeSuccess: 'Успешно объединено.',
    recipes: 'Рецепты',
    recipesUsing: 'Рецепты с {{name}}',
    recipesUsingCaption: 'Откройте рецепт, чтобы изменить его.',
    recipesNone: 'Не используется ни в одном рецепте.',
  },
  recipes: {
    title: 'Рецепты',
    description: 'Задайте рецепты, которые связывают позиции меню с ингредиентами для автоматического учёта остатков.',
    createCard: 'Создать рецепт',
    addIngredient: 'Добавить ингредиент',
    newCardName: 'Название нового рецепта',
    selectHint: 'Выберите рецепт слева, чтобы править его ингредиенты.',
    item: 'ингредиент',
    items: 'ингредиенты',
    noCards: 'Рецептов ещё нет. Создайте выше.',
    colIngredient: 'Ингредиент',
    colSubstitute: 'Заменить на',
    colQty: 'Количество на порцию',
    colCost: 'Себестоимость',
    colPriceDelta: 'Дельта цены',
    totalCost: 'Итого себестоимость',
    costMissing: 'Нет цены за единицу у одного или нескольких ингредиентов',
    noSubstitute: 'Без замены',
    substituteOptional: 'необязательно',
    substituteQtyPlaceholder: 'Количество замены',
    noItems: 'Ингредиентов ещё нет — добавьте выше.',
    prepStock: 'остаток заготовки',
    prepStockOnSale: 'Списывается при продаже',
    batchEquivalent: 'Эквивалент партии',
    legacyPrepSubRecipe: 'Устаревший подрецепт — используйте ингредиент-заготовку',
    prepSubRecipeBlocked: 'Рецепты заготовок не могут быть подрецептами. Добавьте ингредиент заготовки из партий заготовок.',
    prepStandardBatch: 'Стандартная себестоимость партии',
    prepStandardUnit: 'Стандартная себестоимость единицы',
    prepStoredCost: 'Сохранено на ингредиенте',
    prepCostMissing: 'Нет сырьевой себестоимости для',
    prepCostSubRecipes: 'Подрецепты не входят в себестоимость — используйте сырьё в рецепте заготовки.',
    recalcPrepCost: 'Пересчитать стандартную себестоимость',
  },
  sales: {
    title: 'Продажи',
    forcedOnly: 'Показать только принудительно закрытые заказы',
    noOrders: 'Заказов ещё нет.',
    colNumber: '#',
    colTime: 'Время',
    colStatus: 'Статус',
    colTotal: 'Итого',
    colForced: 'Принудительно закрыт',
    colNote: 'Заметка',
  },
  receiptTemplate: {
    title: 'Шаблон чека',
    subtitle: 'Настройте предчековый чек, который печатается на кассе.',
    cafeName: 'Название кафе',
    header: 'Шапка',
    headerPlaceholder: 'Дополнительные строки над позициями (необязательно)',
    footer: 'Подвал',
    footerPlaceholder: 'Заключительное сообщение под итогом',
    paperWidth: 'Ширина бумаги',
    printFontSize: 'Размер шрифта печати',
    fontNormal: 'Обычный',
    fontLarge: 'Крупный (двойная высота)',
    fontXlarge: 'Очень крупный (двойная ширина и высота)',
    printFontSizeHint: 'Использует команды ESC/POS на термопринтере. Очень крупный шрифт вмещает меньше символов в строке.',
    printBold: 'Жирный текст',
    printBoldHint: 'Жирным печатаются название кафе, позиции и итог.',
    preview: 'Предпросмотр',
    save: 'Сохранить шаблон',
    saved: 'Сохранено',
  },
  suppliers: {
    title: 'Поставщики',
    subtitle: 'Ведите поставщиков. Юридические названия подставляются автоматически из утверждённых электронных накладных.',
    addSupplier: 'Добавить поставщика',
    editSupplier: 'Изменить поставщика',
    noSuppliers: 'Поставщиков ещё нет.',
    noMatch: 'Нет поставщиков по вашему запросу.',
    nameRequired: 'Название поставщика обязательно.',
    tinRequired: 'TIN обязателен.',
    colName: 'Название',
    colLegalName: 'Юридическое название',
    colTin: 'TIN',
    colCategory: 'Категория',
    colContact: 'Контакт',
    colPhone: 'Телефон',
    name: 'Название поставщика',
    namePlaceholder: 'например, Fresh Market',
    legalName: 'Юридическое название',
    legalNameHint: 'из электронной накладной',
    tin: 'TIN',
    tinLocked: 'нельзя изменить',
    category: 'Категория',
    contactPerson: 'Контактное лицо',
    contactPersonPlaceholder: 'например, Армен Акопян',
    phone: 'Телефон',
    cat_vegetables: 'Овощи',
    cat_wine: 'Вино и алкоголь',
    cat_milk: 'Молоко и молочные продукты',
    cat_drinks: 'Напитки',
    cat_coffee: 'Кофе',
    cat_food: 'Еда',
    cat_services: 'Услуги',
    cat_cleaning: 'Уборка',
    cat_packaging: 'Упаковка / расходники',
    cat_other: 'Другое',
  },
  floorPlan: {
    title: 'План зала',
    subtitle: 'Разместите залы и столы для обслуживания. POS покажет именно эту схему на экране столов.',
    addTable: 'Добавить стол',
    addRoom: 'Добавить зал',
    roomNamePrompt: 'Название зала (например, Терраса):',
    emptyRoom: 'В этом зале ещё нет столов — нажмите «+ Добавить стол».',
    selectHint: 'Выберите стол на схеме, чтобы изменить его. Перетаскивайте столы, чтобы расставить зал.',
    tableName: 'Название стола',
    seats: 'Мест',
    shape: 'Форма',
    shape_square: 'Квадрат',
    shape_round: 'Круг',
    shape_rect: 'Прямоугольник',
    size: 'Размер',
    room: 'Зал',
    active: 'Активен',
    deactivatedInstead: 'У стола есть прошлые заказы, поэтому он деактивирован, а не удалён.',
  },
  customerDisplay: {
    title: 'Экран гостя',
    subtitle: 'Настройте планшет, обращённый к гостю — баннер ожидания и чаевые по карте.',
    enabled: 'Включить экран гостя',
    enabledHint: 'POS отдаёт страницу на порту 9200; откройте http://<pos-ip>:9200 на планшете.',
    bannerTitle: 'Заголовок баннера',
    bannerMessage: 'Текст баннера',
    bannerImageUrls: 'Изображения баннера (до 4)',
    bannerImageUrlsHint: 'Загрузите изображения или вставьте URL. Показываются на экране ожидания и меняются каждые 5 секунд, если задано несколько.',
    bannerImageUrlN: 'Изображение {{n}}',
    bannerImageUpload: 'Загрузить изображение',
    bannerImageUploading: 'Загрузка…',
    bannerImageClear: 'Удалить',
    bannerImageUrlPlaceholder: 'Или вставьте URL изображения…',
    tipsSection: 'Чаевые по карте',
    tipEnabled: 'Спрашивать чаевые при оплате картой',
    percentPresets: 'Предустановки процентов (%)',
    smallOrderThreshold: 'Порог маленького заказа (֏)',
    smallOrderThresholdHint: 'Ниже этой суммы показываются фиксированные суммы в ֏ вместо процентов.',
    fixedPresets: 'Фиксированные суммы для маленьких заказов (֏)',
    tipTimeout: 'Таймаут чаевых (секунды)',
    tipTimeoutHint: 'Столько времени есть у гостя; кассир может пропустить раньше.',
    fiscalSection: 'Строка чаевых HDM (фискальная)',
    fiscalHint: 'Нужна, чтобы печатать чаевые на фискальном чеке. Оставьте отдел/ADG пустыми, чтобы не печатать фискальную строку чаевых.',
    tipDepartmentId: 'ID отдела чаевых',
    tipAdgCode: 'Код ADG чаевых',
    tipProductCode: 'Код товара чаевых',
    tipProductName: 'Название товара чаевых',
    save: 'Сохранить настройки',
    saved: 'Сохранено',
    loyaltySection: 'Реклама регистрации в лояльности',
    loyaltySectionHint: 'Показать кнопку «Вступить в программу» на экране ожидания. Гость нажимает её и видит QR для регистрации. Нужна ссылка из Лояльность → Ссылки для регистрации.',
    loyaltyEnabled: 'Показывать регистрацию лояльности на экране гостя',
    loyaltySignupUrl: 'URL ссылки регистрации',
    loyaltySignupUrlHint: 'Вставьте публичную ссылку вступления (из Лояльность → копировать ссылку). QR кодирует этот URL. Нужен, чтобы включить акцию.',
    loyaltyUrlRequired: 'Укажите URL ссылки регистрации, прежде чем включать акцию лояльности.',
    loyaltyUrlRequiredHint: 'Добавьте ссылку регистрации ниже — переключатель останется выключенным, пока нет URL.',
    loyaltyQuickLinks: 'Быстрая подстановка из ссылок регистрации',
    loyaltyHeadline: 'Заголовок экрана QR',
    loyaltySubtext: 'Подзаголовок экрана QR (строка выгоды)',
    loyaltyCtaLabel: 'Текст кнопки на экране ожидания',
  },
  rooms: {
    title: 'Номера',
    subtitle: 'Номера для бронирования и вместимость. У каждого номера свой URL фида iCal.',
    add: 'Добавить номер',
    edit: 'Изменить номер',
    empty: 'Номеров ещё нет — добавьте первый, чтобы принимать брони.',
    nameRequired: 'Название номера обязательно.',
    priceRequired: 'Цена за ночь должна быть больше нуля.',
    namePlaceholder: 'например, Номер 1, Garden Suite',
    colName: 'Название',
    colCapacity: 'Вместимость',
    colPrice: 'Цена / ночь',
    colSort: 'Порядок',
    colActive: 'Активен',
    colFeed: 'Фид iCal',
    activeYes: 'Да',
    activeNo: 'Нет',
    copyFeed: 'Копировать ссылку',
    copied: 'Скопировано ✓',
    hdmTitle: 'Фискальный отдел HDM',
    hdmHint: 'Идентификатор отдела, который POS использует при печати фискального чека за бронь номера. Должен совпадать с отделом на устройстве HDM (как «отдел HDM» у категории меню).',
    hdmDept: 'Отдел HDM',
    hdmDeptTitle: 'Идентификатор фискального отдела HDM (должен совпадать с устройством)',
    feedTitle: 'Экспорт доступности iCal',
    feedHint: 'Вставьте ссылку фида номера в Airbnb, Booking.com или Expedia («Import calendar»), чтобы делиться доступностью. В ссылках есть секретный токен — храните их как пароли.',
    rotate: 'Перевыпустить ссылки фидов',
    rotateConfirm: 'Все ранее отправленные ссылки фидов перестанут работать. Продолжить?',
    rotateYes: 'Да, перевыпустить',
    widgetTitle: 'Виджет бронирования',
    widgetHint: 'Публичный календарь доступности, где гости бронируют напрямую. Поделитесь ссылкой или встройте на сайт через iframe.',
    widgetTitleLabel: 'Заголовок виджета',
    widgetTitlePlaceholder: 'По умолчанию — название вашего бизнеса',
    widgetColorLabel: 'Цвет кнопки',
    widgetColorHint: 'Используется для «Забронировать» и «Подтвердить» в публичном виджете.',
    widgetOpen: 'Открыть виджет',
    widgetCopyLink: 'Копировать ссылку',
    widgetCopyEmbed: 'Копировать код встройки',
    notifyEmailsTitle: 'Уведомлять кафе о новых заявках',
    notifyEmails: 'Список почт кафе',
    notifyEmailsPlaceholder: 'cafe@example.com, manager@example.com',
    notifyEmailsHint: 'На эти адреса придёт письмо, когда гость отправит заявку из виджета. Гость по-прежнему получает своё письмо о заявке.',
    photos: 'Фотографии',
    addPhoto: 'Добавить фото',
    photosHint: 'Показываются в виджете бронирования. JPEG, PNG или WebP, до 4 МБ каждое.',
  },
  bookingWidget: {
    kicker: 'Забронировать проживание',
    subtitle: 'Доступность номеров',
    guests_one: '{{count}} гость',
    guests_other: '{{count}} гостей',
    guestsLabel: 'Гости',
    perNight: '/ ночь',
    forStay: 'за {{count}} ночей',
    fullyBooked: 'Нет мест',
    noRooms: 'Доступных номеров ещё нет.',
    loadError: 'Не удалось загрузить доступность. Попробуйте позже.',
    pickCheckin: 'Выберите дату заезда.',
    pickCheckout: 'Теперь выберите дату выезда.',
    nights_one: '{{count}} ночь',
    nights_other: '{{count}} ночей',
    guestName: 'Имя и фамилия',
    phone: 'Номер телефона',
    book: 'Забронировать',
    email: 'Электронная почта',
    bookSuccessTitle: 'Заявка получена',
    bookSuccess: 'Мы напишем на почту, когда объект подтвердит или отклонит заявку. Это ещё не подтверждённая бронь.',
    colRoom: 'Номер',
    bookConflict: 'Эти даты только что заняли. Выберите другие.',
    bookError: 'Что-то пошло не так. Попробуйте ещё раз.',
    checkIn: 'Заезд',
    checkOut: 'Выезд',
    addDate: 'Добавить дату',
    resetDates: 'Сбросить',
    chooseDates: 'Выбрать даты',
    reserve: 'Забронировать',
    unavailable: 'Недоступно',
    tooSmall: 'В этом номере меньше мест, чем {{count}} гостей.',
    tooSmallBadge: 'Мало мест',
    availableCount: 'Доступно номеров: {{count}}',
    unavailableCount: 'Недоступно: {{count}}',
    noMatch: 'На эти даты свободно ничего нет. Попробуйте другие.',
    browseHint: 'Выберите даты, чтобы увидеть свободное — или посмотрите номера ниже.',
    stayTotal: 'Итого',
    bookAnother: 'Забронировать ещё',
    back: 'Все номера',
    guestDetails: 'Ваши данные',
    payOnSite: 'Оплата на месте. Сейчас ничего не списывается.',
    confirmBooking: 'Отправить заявку',
    sleeps: 'До {{count}} гостей',
    prevPhoto: 'Предыдущее фото',
    nextPhoto: 'Следующее фото',
    prevMonth: 'Предыдущий месяц',
    nextMonth: 'Следующий месяц',
    fewerGuests: 'Меньше гостей',
    moreGuests: 'Больше гостей',
    datesNoLongerAvailable: 'Этот номер больше не свободен на новые даты. Выберите другой.',
    done: 'Готово',
    viewPhotos: 'Смотреть фото',
    closePhotos: 'Закрыть фото',
    photoOf: '{{current}} / {{total}}',
  },
  bookings: {
    title: 'Бронирования',
    subtitle: 'Календарь доступности номеров. Нажмите свободный день, чтобы забронировать, или бронь — чтобы изменить.',
    subtitleTable: 'Все брони выбранного месяца. Нажмите строку, чтобы открыть или изменить.',
    viewCalendar: 'Календарь',
    viewTable: 'Таблица',
    add: 'Новая бронь',
    edit: 'Бронь',
    today: 'Сегодня',
    colRoom: 'Номер',
    colNights: 'Ночи',
    colStatus: 'Статус',
    statusConfirmed: 'Подтверждена',
    statusPending: 'Ожидает',
    statusRejected: 'Отклонена',
    guestEmail: 'Электронная почта',
    emailInvalid: 'Введите корректный адрес почты.',
    requestBanner: 'Заявка с сайта — даты свободны, пока вы не подтвердите.',
    confirmRequest: 'Подтвердить заявку',
    rejectRequest: 'Отклонить',
    confirmRequestAsk: 'Подтвердить эту заявку?',
    rejectRequestAsk: 'Отклонить эту заявку?',
    confirmRequestYes: 'Да, подтвердить',
    rejectRequestYes: 'Да, отклонить',
    reviewError: 'Не удалось обновить заявку. Попробуйте ещё раз.',
    noBookings: 'В этом месяце броней нет.',
    noRooms: 'Нет активных номеров — сначала добавьте номера (Управление → Бронирования).',
    clickToBook: 'Нажмите, чтобы создать бронь',
    guestName: 'Имя гостя',
    phone: 'Телефон',
    checkIn: 'Заезд',
    checkOut: 'Выезд',
    nights: '{{count}} ночей',
    adults: 'Взрослые',
    kids: 'Дети',
    sourceLabel: 'Источник',
    note: 'Заметка',
    roomRequired: 'Выберите номер.',
    nameRequired: 'Имя гостя обязательно.',
    phoneRequired: 'Номер телефона обязателен.',
    datesInvalid: 'Выезд должен быть после заезда.',
    adultsRequired: 'Нужен хотя бы один взрослый.',
    overCapacity: 'Слишком много гостей для этого номера (вместимость {{capacity}}).',
    conflict: 'Этот номер уже занят на эти даты.',
    cancelBooking: 'Отменить бронь',
    cancelYes: 'Да, отменить',
    cancelled: 'Отменена',
    close: 'Закрыть',
    amount: 'Сумма (AMD)',
    amountHint: 'По умолчанию цена номера × ночи; можно изменить.',
    amountRequired: 'Сумма должна быть больше нуля.',
    paymentOption: 'Вариант оплаты',
    paymentOptionRequired: 'Вариант оплаты обязателен.',
    paymentOptionValue: {
      on_site: 'На месте',
      online: 'Онлайн',
      free: 'Бесплатно',
    },
    freeHint: 'Бесплатное проживание. Номер занят, оплата не берётся.',
    freeAfterPayment: 'По этой брони уже есть оплата. Сначала оформите возврат, затем отметьте её бесплатной.',
    paymentStatusLabel: 'Статус оплаты',
    paymentStatus: {
      unpaid: 'Не оплачено',
      pending: 'Ожидает',
      paid: 'Оплачено',
      failed: 'Ошибка',
    },
    tender: {
      cash: 'Наличные',
      card: 'Карта',
    },
    fiscalTitle: 'Фискальный чек',
    fiscalNumber: 'Фискальный #',
    fiscalTotal: 'Фискальная сумма',
    fiscalCrn: 'CRN',
    fiscalTin: 'TIN',
    fiscalTime: 'Напечатан',
    fiscalNone: 'Фискального чека ещё нет.',
    refund: 'Возврат',
    refundBooking: 'Вернуть бронь',
    refundTitle: 'Возврат брони',
    refundConfirmCancel: 'Бронь будет отменена после выдачи фискального чека возврата.',
    refundReturnCash: 'Вернуть {{amount}} наличными',
    refundReturnCard: 'Вернуть {{amount}} на карту',
    refunding: 'Выпуск чека возврата…',
    refundSuccess: 'Возврат выполнен — фискальный #{{fiscal}}. Бронь отменена.',
    refundFailed: 'Возврат не удался: {{msg}}',
    refundFiscalTitle: 'Чек возврата',
    refundOnPosOnly: 'Оплачено с фискальным чеком — сделайте возврат на POS, чтобы выпустить чек возврата и отменить бронь.',
    payConfirmTitle: 'Подтвердить оплату',
    payConfirmCash: 'Списать {{amount}} наличными и напечатать фискальный чек?',
    payConfirmCard: 'Списать {{amount}} с карты и напечатать фискальный чек?',
    payConfirmYes: 'Подтвердить оплату',
    source: {
      airbnb: 'Airbnb',
      expedia: 'Expedia',
      booking: 'Booking.com',
      web: 'Сайт',
      instagram: 'Instagram',
      on_site: 'На месте',
      other: 'Другое',
    },
  },
  bookingInsights: {
    title: 'Аналитика бронирований',
    subtitle: 'Загрузка, ADR, RevPAR и каналы за проживания в выбранном периоде.',
    period_7d: '7 дней',
    period_30d: '30 дней',
    period_90d: '90 дней',
    kpiOccupancy: 'Загрузка',
    kpiAdr: 'ADR',
    kpiRevpar: 'RevPAR',
    kpiRevenue: 'Оплаченная выручка',
    kpiStays: 'Подтверждённые проживания',
    kpiAvgLos: 'Средняя длительность проживания',
    kpiCollection: 'Доля собранных платежей',
    kpiOutstanding: 'К получению',
    kpiComplimentary: 'Бесплатно',
    kpiCancelRate: 'Доля отмен',
    compHint: 'Занятые ночи, не входящие в выручку и ADR',
    adrHint: 'Оплаченная выручка ÷ оплаченные номер-ночи',
    revparHint: 'Оплаченная выручка ÷ доступные номер-ночи',
    revenueHint: 'Собрано за период',
    staysHint: 'Неотменённые заезды',
    cancelledCount: '{{count}} отменено',
    roomNights: 'номер-ночи',
    nightsCount: '{{count}} ночей',
    nightsShort: 'ночей',
    staysShort: 'проживаний',
    trendTitle: 'Ежедневная собранная выручка',
    channelMixTitle: 'Выручка по каналам',
    roomPerformanceTitle: 'Эффективность номеров',
    paymentMixTitle: 'Статус оплаты',
    bySource: 'По источнику',
    byPaymentOption: 'По варианту оплаты',
    byRoom: 'По номеру',
    recentPaid: 'Недавние расчёты',
    colSource: 'Источник',
    colOption: 'Вариант оплаты',
    colRoom: 'Номер',
    colBookings: 'Брони',
    colPaid: 'Оплачено',
    colRevenue: 'Выручка',
    colGuest: 'Гость',
    colDates: 'Даты',
    colAmount: 'Сумма',
    colFiscal: 'Фискальный #',
    colTender: 'Способ',
    noData: 'В этом периоде нет пересекающихся проживаний.',
    noPaidBySource: 'Оплаченной выручки по каналам ещё нет.',
    noPaidYet: 'В этом периоде нет оплаченных броней.',
  },
  staffComps: {
    title: 'Комплименты сотрудникам',
    subtitle: 'Бесплатные принудительные закрытия и питание сотрудников, списанное как отход — по получателю и типу.',
    period_7d: '7 дней',
    period_30d: '30 дней',
    period_90d: '90 дней',
    kpiOrders: 'Комплимент-заказы',
    kpiTotal: 'Общая сумма',
    kpiAvg: 'Среднее на заказ',
    byRecipient: 'По получателю',
    byType: 'По типу комплимента',
    colRecipient: 'Получатель',
    colType: 'Тип',
    colOrders: 'Заказы',
    colTotal: 'Итого',
    noData: 'В этом периоде нет структурированных комплиментов.',
    unassigned: 'Не назначено',
    unknownRecipient: 'Неизвестно',
  },
  compTypes: {
    staff_meal: 'Питание сотрудников',
    owner: 'Владелец',
    guest: 'Гость',
    training: 'Обучение',
    marketing: 'Маркетинг',
    waste: 'Списание',
    other: 'Другое',
  },
  demo: {
    tryDemo: 'Попробовать живое демо',
    or: 'или',
    signInHint: 'Общее демо — данные сбрасываются каждую ночь. Смотрите свободно.',
    banner: 'Демо-среда — тестовые данные сбрасываются каждую ночь. Ваши изменения не сохранятся навсегда.',
  },
} as const;
